var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating w-full border rounded overflow-hidden"},[_c('div',{staticClass:"balance p-1 text-center",class:{ 'showbalance': _vm.showbalance },style:('width:' + _vm.percent + '%;')},[_vm._v("\n    "+_vm._s(_vm._f("ceil")(_vm.value))+"\n    "),(this.mode !== 'school')?_c('span',[_vm._v("%")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee72e75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rating.vue
// module id = null
// module chunks = 